import { render, staticRenderFns } from "./BrowserWarning.vue?vue&type=template&id=2facaea8&scoped=true&"
import script from "./BrowserWarning.vue?vue&type=script&lang=js&"
export * from "./BrowserWarning.vue?vue&type=script&lang=js&"
import style0 from "./BrowserWarning.vue?vue&type=style&index=0&id=2facaea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2facaea8",
  null
  
)

export default component.exports